import { render, staticRenderFns } from "./BarcodeReadResultCard.vue?vue&type=template&id=145bbac5&scoped=true"
import script from "./BarcodeReadResultCard.vue?vue&type=script&lang=ts"
export * from "./BarcodeReadResultCard.vue?vue&type=script&lang=ts"
import style0 from "./BarcodeReadResultCard.vue?vue&type=style&index=0&id=145bbac5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "145bbac5",
  null
  
)

export default component.exports